import { Badge, Box, Button, DialogBody, Flex, HStack, IconButton, Stack, Text } from "@chakra-ui/react";
import { Form, UI } from "components";
import useProduct from "hooks/useProduct";

export default function Add({ data, ...props }){

    const product = useProduct(data?.id)

    return(
    <UI.Dialog size="xs" title={data?.name} {...props}>
        <DialogBody>
            <Stack>
                <UI.Show visible={!!product.data?.category}><Badge>{product.data?.category?.name}</Badge></UI.Show>
                {/* <Box dangerouslySetInnerHTML={{ __html: product.data?.body }} /> */}

                <Form.Container>

                    <Flex>
                        <IconButton colorPalette="red"><UI.Icon name="add" /></IconButton>
                        <Box><Form.Text required variant="ghost" w="80px" type="number" textAlign="center" defaultValue={0} /></Box>
                        <IconButton colorPalette="green"><UI.Icon name="remove" /></IconButton>
                    </Flex>

                    <Button>Adicionar</Button>

                </Form.Container>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}